'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/nextjs';
import { SonnerToaster } from '@extern/ui/sonner';
import { TooltipProvider } from '@extern/ui/tooltip';
import { GoogleTagManager } from '@next/third-parties/google';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { ReactQueryProvider } from '@/infra/react-query/react-query-provider';
import { PageView } from '@/lib/analytics/page-view';
import { PostHogProvider } from '@/lib/analytics/posthog-provider';
import { getEnv } from '@/utils/env';
import { LogRocketInit } from './log-rocket-init';
import { SegmentScript } from './segment-script';
import { TikTokPixelScript } from './tik-tok-pixel-script';
interface AppProvidersProps {
  children?: ReactNode;
}
export function AppProviders(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getEnv("GOOGLE_TAG_MANAGER_ID");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const gtmId = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = gtmId ? <GoogleTagManager gtmId={gtmId} /> : null;
    t3 = <SonnerToaster />;
    t4 = <LogRocketInit />;
    t5 = <PageView />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <ClerkProvider><PostHogProvider><ReactQueryProvider><NuqsAdapter><TooltipProvider>{children}{t2}{t3}{t4}{t5}</TooltipProvider></NuqsAdapter></ReactQueryProvider></PostHogProvider></ClerkProvider>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SegmentScript />;
    t8 = <TikTokPixelScript />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6) {
    t9 = <>{t6}{t7}{t8}</>;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}